import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useStudent } from "@/lib/auth";

export function useSavedUniversities() {
  const { student } = useStudent();
  const [saved, setSaved] = useState(new Set());

  useEffect(() => {
    if (!student) {
      setSaved(new Set());
      return;
    }
    api.get("/student/saved")
      .then((r) => setSaved(new Set(r.data.map((u) => u.slug))))
      .catch(() => {});
  }, [student]);

  const toggle = useCallback(async (slug) => {
    if (!student) {
      toast.info("Sign in with Google to save universities to your profile.");
      return;
    }
    const previous = new Set(saved);
    const next = new Set(saved);
    const isSaving = !next.has(slug);
    if (isSaving) next.add(slug); else next.delete(slug);
    setSaved(next);
    try {
      await api.post(`/student/saved/${slug}`);
      toast.success(isSaving ? "Saved to your profile." : "Removed from saved universities.");
    } catch {
      setSaved(previous);
      toast.error("Could not update saved universities. Please try again.");
    }
  }, [saved, student]);

  return { saved, toggle, student };
}
